import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './conclusion.types';
import * as constants from './conclusion.constants';

export const storeConclusion = generateStoreResourceAction<types.IConclusion>(constants.STORE_CONCLUSION);
export const clearConclusion = generateClearResourceAction(constants.CLEAR_CONCLUSION);
